import React, { useCallback, useEffect, useState } from 'react';
import cx from 'classnames';
import { useTranslations } from 'next-intl';
import { Accept, useDropzone, FileRejection } from 'react-dropzone';
import UploadCommonModal from '@/components/UploadCommonModal';
import { ActionTypeEnum, preCheckFiles, IProcessFile,  UploadType } from '@/components/ModuleEditor/config';
import {
  IMAGE_ACCEPT_FORMAT,
  VIDEO_ACCEPT_FORMAT,
  MAX_IMAGE_SIZE,
  MAX_PHOTOS,
  MAX_VIDEOS,
  MAX_VIDEO_SIZE,
  IMAGE_ACCEPT_FORMAT_DISPLAY,
  VIDEO_ACCEPT_FORMAT_DISPLAY,
} from '@/constants/upload';
import { ErrorMsg } from '@/components/ModuleEditor/config';
import Styles from './index.module.scss';

export interface IOnChangeCbParam {
  acceptFiles: IProcessFile[];
  rejectFiles: IProcessFile[];
}
interface IUploadModal {
  uploadType: ActionTypeEnum;
  title: string;
  multiple?: boolean;
  onCancel: () => void;
  onChange: (cbParams: IOnChangeCbParam) => void;
}
const UploadModal = ({
  uploadType,
  title,
  multiple = true,
  onCancel,
  onChange,
}: IUploadModal) => {
  const [type, setType] = useState(uploadType);
  const [error, setError] = useState(null);
  const t = useTranslations();

  useEffect(() => {
    setType(uploadType);
  }, [uploadType]);

  const onDrop = useCallback((acceptedFiles: File[], rejects: FileRejection[]) => {
    const rejectsFirstFile:any = rejects[0]?.file ? [rejects[0]?.file]: [];
    const allFiles:any = acceptedFiles.concat(rejectsFirstFile);
    preCheckFiles(allFiles, type)
      .then(({ acceptFiles, rejectFiles }:IOnChangeCbParam)=>{
        if(acceptFiles.length > 0) {
          setError(null);
          onChange({ acceptFiles, rejectFiles});
        } else {
          setError(rejectFiles[0]?.error);
        }
      })
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const accept:Accept = {};

  (type === ActionTypeEnum.video ? VIDEO_ACCEPT_FORMAT : IMAGE_ACCEPT_FORMAT).split(', ').forEach(format=>{
    accept[format] = [];
  })

  const {getRootProps, getInputProps, isDragActive} = useDropzone({
    onDrop,
    maxFiles: uploadType === ActionTypeEnum.video ? MAX_VIDEOS : MAX_PHOTOS,
    maxSize: uploadType === ActionTypeEnum.video ? MAX_VIDEO_SIZE : MAX_IMAGE_SIZE,
    accept,
    multiple,
  });

  return (
    <UploadCommonModal
      title={title}
      onCancel={onCancel}
      contentClassName={Styles.content}
    >
      <div className={Styles.uploadWrapper}>
        <input {...getInputProps()} />
        {
          type === ActionTypeEnum.photo ?
            <div className={Styles.uploadPhotoWrapper}>
              <div {...getRootProps()} className={cx(Styles.uploadPhoto, {[Styles.uploadWrapperActive]: isDragActive, [Styles.uploadWrapperError]: error})}>
                <i className={Styles.icon}></i>
              </div>
              <p className={Styles.error}>{error && t(ErrorMsg(type, error).id, ErrorMsg(type, error)?.value)}</p>
              <button className={Styles.uploadBtn} {...getRootProps()}>{t("upload_photo_btn")}</button>
              <div className={Styles.uploadTips}>图片格式要求：支持 {IMAGE_ACCEPT_FORMAT_DISPLAY} 格式</div>
            </div>
            :
            <div className={Styles.uploadVideoWrapper} {...getRootProps()} >
              <div className={cx(Styles.uploadVideo, {[Styles.uploadWrapperActive]: isDragActive, [Styles.uploadWrapperError]: error})}>
                <i className={Styles.icon}></i>
                <p className={Styles.dragText}>{t("drag_video_text")}</p>
                <p className={Styles.tipsText}>{t("review_video_tips")}</p>
                <button className={Styles.uploadBtn}>{t("upload_video_btn")}</button>
              </div>
              <p className={Styles.error}>{error && t(ErrorMsg(type, error).id, ErrorMsg(type, error)?.value)}</p>
              <div className={Styles.uploadTips}>视频格式要求：支持 {VIDEO_ACCEPT_FORMAT_DISPLAY} 格式</div>
            </div>
        }
      </div>
    </UploadCommonModal>
  );
}

export default UploadModal;
